import {Component, Inject} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';

@Component({selector: 'add-user-dialog', templateUrl: './add-user-dialog.html'})
export class AddUserDialogComponent {
  email = new FormControl('', [
    Validators.pattern(
        '^[a-z0-9!#$%&\'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$'),
    Validators.required
  ]);
  name = new FormControl('', [Validators.required]);

  constructor(
      public dialogRef: MatDialogRef<AddUserDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any) {}

  getErrorMessage() {
    return this.email.hasError('required') ?
        'You must enter an email' :
        this.email.hasError('pattern') ? 'Not a valid email' : '';
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/users/add/add.user.dialog.component.ts